#import "./StaffQuizAttemptFields.graphql"

query GetMyQuizAttempt($id: ID!) {
  myQuizAttempt(id: $id) {
    ...StaffQuizAttemptFields
  }
}
